import cn from 'classnames'
import React from 'react'

import styles from './NavigationIcon.module.scss'

type NavigationIconProps = React.HTMLAttributes<HTMLElement>

function NavigationIcon({ children, className, ...props }: React.PropsWithChildren<NavigationIconProps>) {
  return (
    <span className={cn(styles.root, className)} {...props}>
      {children}
    </span>
  )
}

export default NavigationIcon
